import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import find from 'lodash/find';

import { validNumeric } from '@jerry-serverless/tools/lib/validators';
import { states } from '@jerry-serverless/tools/lib/states';
import type { AddressInput } from '@jerry-serverless/types';

export { AddressInput };

export const ADDRESS_INPUT_FRAGMENT = `
  street
  line2
  city
  state
  zip
  county
`;

export interface Address extends AddressInput {
  id?: string;
}

export const ADDRESS_FRAGMENT = `
  id
  ${ADDRESS_INPUT_FRAGMENT}
`;

/**
 * Parse address from JSON object.
 *
 * @param obj
 */
export const parseAddress = (obj: Record<string, string>): AddressInput | null => {
  if (!isObject(obj)) return null;

  if (!obj.street || !isString(obj.street)) return null;
  const street = obj.street;

  if (obj.line2 && !isString(obj.line2)) return null;
  const line2 = obj.line2 || '';

  if (!obj.city || !isString(obj.city)) return null;
  const city = obj.city;

  if (!isString(obj.state)) return null;
  const foundState = find(states, ({ abbreviation }) => abbreviation === obj.state);
  if (!foundState) return null;
  const state = foundState.abbreviation;

  if (!isString(obj.zip) || !validNumeric(obj.zip, 5, true)) return null;
  const zip = obj.zip;

  if (obj.county && !isString(obj.county)) return null;
  const county = obj.county;

  return {
    street,
    line2,
    city,
    state,
    zip,
    county,
  };
};
